module.exports = __webpack_public_path__ + "img/collection-memoireRingsExclusive.540cbe8.webp";